import { Badge, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { ParametroUrbanistico } from "store/modules/consultaprevia/types";

// O backend manda o valor como número e o símbolo à parte (%, m, m², …).
// Formatar aqui evita "0.65" aparecendo para quem lê "0,65".
const formatarValor = (parametro: ParametroUrbanistico) => {
  const valor = parametro.valor.toLocaleString("pt-BR", {
    maximumFractionDigits: 4
  });

  return parametro.simboloUnidade
    ? `${valor} ${parametro.simboloUnidade}`
    : valor;
};

export const ParametrosUrbanisticos = ({
  parametros
}: {
  parametros: ParametroUrbanistico[];
}) => {
  const borderColor = useColorModeValue("gray.100", "gray.800");

  if (!parametros?.length) {
    return <TextGray fontSize="sm">Sem parâmetros urbanísticos.</TextGray>;
  }

  return (
    <Box>
      {parametros.map((parametro) => (
        <Box
          key={`${parametro.nome}-${parametro.valor}`}
          py="2"
          borderBottom="1px solid"
          borderBottomColor={borderColor}
          _last={{ borderBottom: "none" }}
        >
          <Flex justifyContent="space-between" alignItems="baseline" gap="3">
            <Text fontSize="sm" fontWeight="medium">
              {parametro.nome}
            </Text>
            <Text fontSize="sm" fontWeight="bold" whiteSpace="nowrap">
              {formatarValor(parametro)}
            </Text>
          </Flex>

          {parametro.unidadeMedida &&
            parametro.unidadeMedida !== parametro.simboloUnidade && (
              <TextGray fontSize="xs">{parametro.unidadeMedida}</TextGray>
            )}

          {/* Um parâmetro condicional não vale sempre. Esconder a condição
              transformaria um "depende" em uma promessa. */}
          {parametro.aplicacaoCondicional && (
            <Box mt="1">
              <Badge colorScheme="orange" fontSize="0.65rem">
                Aplicação condicional
              </Badge>
              {parametro.condicaoAplicacao && (
                <TextGray fontSize="xs" mt="1">
                  {parametro.condicaoAplicacao}
                </TextGray>
              )}
            </Box>
          )}

          {parametro.observacao && (
            <TextGray fontSize="xs" mt="1" fontStyle="italic">
              {parametro.observacao}
            </TextGray>
          )}
        </Box>
      ))}
    </Box>
  );
};
